export default __webpack_public_path__ + "static/media/download_play_store.1d8f7bc8.svg";